var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('wordpress-loader',{attrs:{"loading":_vm.loading}}),(!_vm.loading && !_vm.error.show)?_c('live-campaign',{attrs:{"campaign":_vm.campaign}}):_vm._e(),(_vm.error.show)?_c('live-error'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }